import SvgIcon from '@mui/material/SvgIcon';
import * as React from 'react';
const SvgWarningAmberOutlined = (props)=>/*#__PURE__*/ React.createElement(SvgIcon, {
        ...props,
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "m22.064 18.469-8.57-14.625A1.7 1.7 0 0 0 12.007 3c-.578 0-1.157.281-1.522.844L1.918 18.469c-.622 1.12.2 2.531 1.52 2.531h17.14c1.317 0 2.14-1.406 1.486-2.531m-18.23.602 8.137-13.95 8.209 13.95zm8.173-3.813a1.263 1.263 0 1 0 0 2.527 1.263 1.263 0 0 0 0-2.527m-.964-6.15v3.856a.965.965 0 0 0 1.929 0V9.107a.965.965 0 0 0-1.93 0"
    }));
export default SvgWarningAmberOutlined;
